module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDialog),
      expression: "showDialog"
    }],
    attrs: {
      "title": "Forgot Email",
      "customClass": "customWidth",
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "visible": "false",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "account-box"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('p', {
    staticClass: "instructionalText"
  }, [_vm._v("\n             Please contact customer support at: "), _c('strong', [_vm._v("1(888)-233-4445"), _c('br'), _c('br'), _vm._v(" We will assist you in retreiving the email address associated with your account.")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row-block"
  }, [_c('div', {
    staticClass: "row"
  })])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-044cbabc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotEmail.vue
// module id = 1264
// module chunks = 2